import { http } from '../core/http';

/**
 * 上传图片
 * @export
 * @param {Object} [params] - 
 * @param {string} [params.type] - product user step
 * @returns
 */
export async function upload(params: any) {
  return await http.post('/upload', { params });
}

/**
 * 订单支付
 * @export
 * @param {Object} [params]
 * @param {integer} [params.orderid]
 * @param {integer} [params.type] 1余额支付 2支付宝支付
 * @param {string} [params.token]
 */
export async function getPingpayOrder({ orderid = 0, type = 1, token = '' } = {}): Promise<any> {
  return await http.post('/api/order/pingpayOrder', { orderid, type, token })
}

/**
 * 导入页面获取导入记录和模板地址的接口
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function toleadItems(token = '', id = '', original_name = '', file_path = '', error_file_path = '', remark = '', created_by = '', created_at = '') {
  return await http.get('/index.php?route=vapi/order/getTemplate', {
    params: { token, id, original_name, file_path, error_file_path, remark, created_by, created_at }
  });
}

export async function getImportTemplateList(token = '', id = '', original_name = '', file_path = '', error_file_path = '', remark = '', created_by = '', created_at = '') {
  return await http.get('/index.php?route=vapi/order/getTemplate', {
    params: { token, id, original_name, file_path, error_file_path, remark, created_by, created_at }
  });
}

/**
 *  上传的接口
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function uploadingItme(file: FormData, token = '') {
  return await http.post('/index.php?route=vapi/order/importOrder',
    {
      file,
      token
    });
}

/**
 * 充值
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function rechargeOrder({ money = 0, type = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=vapi/order/rechargeOrder', { money, type })
}

export async function isRechargeOrderPaid({ orderId = '' } = {}): Promise<any> {
  return await http.post('/index.php?route=extension/payment/wechat_pay/isRechargeOrderPaid', { orderId })
}

/**
 * 充值记录
 * @export
 * @param {Object} [params]
 * @param {string} [params.token]
 */
export async function rechargeList(): Promise<any> {
  // return await http.post('/api/order/rechargeList')
  return await http.post('/index.php?route=vapi/bill/rechargeList')
}


export async function myBill(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/bill/myBill', params)
}

export async function myBillDetails(params: any): Promise<any> {
  return await http.post('/index.php?route=vapi/bill/myBillDetails', params)
}

/**
* 手动推单
* @export
* @param {Object} [params] - 
* @returns
*/
export async function handPushOrder({ file = '' }): Promise<any> {
  // return await http.post('/api/order/handPushOrder', file);
  return await http.post('/index.php?route=vapi/order_push/handPushOrder', file);
}

/**
* 产品报缺
* @export
* @param {Object} [params] - 
* @returns
*/
export async function productBaoque({ lan_id = '', is_dubug = 1 }): Promise<any> {
  return await http.post('/api/order/product_baoque', { lan_id, is_dubug });
}

/**
* 商品热卖推荐，新品速递
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHotProduct({ type = '', limit = 10 }): Promise<any> {
  // return await http.post('/api/index/getProHot', {type,limit});
  return await http.post('/index.php?route=vapi/index/getProHot', { type, limit });
}

/**
* 常见问题帮助
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getHelp(): Promise<any> {
  // return await http.post('/api/index/getHelp');
  return await http.post('/index.php?route=vapi/index/getHelp');
}

/**
* 首页统计数据、基本数据
* @export
* @param {Object} [params] - 
* @returns
*/
export async function getIndexInfo(): Promise<any> {
  // return await http.post('/api/index/getInfo');
  return await http.post('/index.php?route=vapi/index/getInfo');
}

/**
* 刊登-添加属性
* @export
* @param {Object} [params] - 
* @returns
*/
export async function attributeAdd({ code = '', is_display = 1, is_require = 0, module = '', name = '', platform = '', product_type = '', status = 0, values = '' }): Promise<any> {
  return await http.post('/api/Attribute/add', { code, is_display, is_require, module, name, platform, product_type, status, values });
}

/**
 * 刊登-查询属性
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getAttributeAll(): Promise<any> {
  return await http.get('/api/attribute/all');
}

/**
 * 刊登-删除属性
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteAttribute({ id = '' }): Promise<any> {
  return await http.post('/api/attribute/delete', { id });
}

/**
* 刊登-修改属性
* @export
* @param {Object} [params] - 
* @returns
*/
export async function attributeUpdate({ id = '', code = '', is_display = 1, is_require = 0, module = '', name = '', platform = '', product_type = '', status = 0, values = '' }): Promise<any> {
  return await http.post('/api/Attribute/update', { id, code, is_display, is_require, module, name, platform, product_type, status, values });
}

/**
 * 刊登-查询产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getProductTitleAll({ name = '', start_time = '', end_time = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/all', { name, start_time, end_time });
}


/**
 * 刊登-删除标题模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteProductRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/delete', { id });
}

/**
 * 刊登-添加产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addProductRules({ name = '', rules = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/add', { name, rules });
}

/**
 * 刊登-修改产品标题规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateProductTitleAll({ name = '', id = '', rules = '' }): Promise<any> {
  return await http.post('/api/product_name_rules/update', { name, id, rules });
}



/**
 * 刊登-查询sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getSkuAll({ name = '', start_time = '', end_time = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/all', { name, start_time, end_time });
}


/**
 * 刊登-删除sku模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteSkuRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/delete', { id });
}

/**
 * 刊登-添加sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addSkuRules({ name = '', parent_rule = '', child_rule = '', simple_rule = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/add', { name, parent_rule, child_rule, simple_rule });
}

/**
 * 刊登-修改sku规则模板
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateSkuAll({ name = '', id = '', parent_rule = '', child_rule = '', simple_rule = '' }): Promise<any> {
  return await http.post('/api/product_sku_rules/update', { name, id, parent_rule, child_rule, simple_rule });
}


/**
 * 刊登-查询关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getKeywordsAll(): Promise<any> {
  return await http.post('/api/product_keywords/all');
}


/**
 * 刊登-删除关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function deleteKeywordsRules({ id = '' }): Promise<any> {
  return await http.post('/api/product_keywords/delete', { id });
}

/**
 * 刊登-添加关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addKeywordsRules({ name = '', parent = 0 }): Promise<any> {
  return await http.post('/api/product_keywords/add', { name, parent });
}

/**
 * 刊登-修改关键词组
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function updateKeywordsAll({ name = '', id = '', content = '' }): Promise<any> {
  return await http.post('api/product_keywords/update', { name, id, content });
}


/**
 * 刊登-查询条形码
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getGtinsAll({ generate_type = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/gtins', { generate_type });
}


/**
 * 刊登-改变条形码状态
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function changeGtins({ ids = '', status = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/changeGtinsStatus', { ids, status });
}

/**
 * 刊登-添加条形码
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function addGtins({ generate_type = 0, type = 0, content = '' }): Promise<any> {
  return await http.post('/api/product_gtins/add', { generate_type, type, content });
}

/**
 * 刊登-查询条形码详情
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function getGtinsDetailAll({ generate_type = 0, gtin_id = 0, keyword = '', status = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/gtins', { generate_type, gtin_id, keyword, status });
}

/**
 * 刊登-改变条形码详情状态
 * @export
 * @param {Object} [params] - 
 * @returns
 */
export async function changeGtinsDetail({ ids = '', status = 0, gtin_id = 0 }): Promise<any> {
  return await http.post('/api/product_gtins/changeGtinsStatus', { ids, status, gtin_id });
}

/**
 * 1.材质渲染下拉框带搜索接口
 * @param {Object} [params] - 
 */
export async function tuidanCans({ model = '' }): Promise<any> {
  // return await http.post('/api/tuidan/cans',{keyword})
  return await http.post('/index.php?route=vapi/order_push/getGuige', { model })
}

/**
 * 2.款号渲染下拉框带搜索接口
 * @param {Object} [params] - 
 */
export async function tuidanStyles({ keyword = '' }): Promise<any> {
  // return await http.post('/api/tuidan/styles',{keyword})
  return await http.post('/index.php?route=vapi/order_push/styles', { keyword })
}
